module.exports = __webpack_public_path__ + "static/media/2.809f8a16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mogilev/2.jpg
// module id = 235
// module chunks = 0